import SAP from 'assets/icons/SAP';
import Workable from 'assets/icons/Workable';
import Drawer from 'common/components/Drawer';
import Loader from 'common/components/Loader';
import React from 'react';
import IntegrationCard from 'settings/components/IntegrationCard';
import IntegrationFormRender from 'settings/components/IntegrationFormRender';
import IntegrationFormTemplate from 'settings/components/IntegrationFormTemplate';
import SAPSFIntegrationActionsAndStatus from 'settings/components/SAPSFIntegrationActionsAndStatus';
import { useIntegrationSettings } from 'settings/contexts/IntegrationSettingsContext';

import DefaultIntegrationForm from './DefaultIntegrationForm';

const IntegrationsSettingsForm = () => {
  const {
    selectedIntegration,
    setSelectedIntegration,
    isLoadingCompanySettings,
    handleCardClick,
    t,
  } = useIntegrationSettings();

  const integrations = [
    {
      name: 'Workable',
      slug: 'WORKABLE',
      type: 'api',
      icon: <Workable size={32} />,
      status: () => null, // default is null showing integration status component
      tabs: [
        {
          slug: 'connection',
          label: t('connection'),
          form: () => null,
        },
      ],
    },
    {
      name: 'SAP SuccessFactors',
      slug: 'SAPSF',
      type: 'credentials',
      icon: <SAP size={32} />,
      status: () => <SAPSFIntegrationActionsAndStatus />,
      tabs: [
        {
          slug: 'connection',
          label: t('connection'),
          form: () => <DefaultIntegrationForm />,
        },
      ],
    },
  ];

  return (
    <div className='relative w-full'>
      {isLoadingCompanySettings ? (
        <Loader />
      ) : (
        <>
          <div className='flex flex-wrap gap-6 mt-6'>
            {integrations.map((integration, index) => (
              <IntegrationCard
                key={index}
                integration={integration}
                handleCardClick={handleCardClick}
              />
            ))}
          </div>

          <Drawer
            isOpen={!!selectedIntegration}
            setIsOpen={() => setSelectedIntegration(null)}
            side='right'
            size='medium'
            outsideClickable
          >
            {selectedIntegration && (
              <IntegrationFormTemplate>
                <IntegrationFormRender />
              </IntegrationFormTemplate>
            )}
          </Drawer>
        </>
      )}
    </div>
  );
};

export default IntegrationsSettingsForm;
